import * as React from 'react';
import styles from './DashboardView.module.css';
import HelpLink from './HelpLink';

interface DashboardViewProps {
  title?: string;
  /** Breadcrumb trail and its derived back link, rendered above the heading. */
  breadcrumbs?: React.ReactNode;
  children: React.ReactNode;
}

const DashboardView: React.FC<DashboardViewProps> = ({ children, title, breadcrumbs }) => {
  return (
    <div className={styles.DashboardView}>
      {breadcrumbs}
      {title && (
        <div className={styles.DashboardHeader}>
          <h1>{title}</h1>
          <HelpLink />
        </div>
      )}
      {children}
    </div>
  );
};

export default DashboardView;
